import { useState } from "react";
import { FormattedMessage } from "react-intl";

import { QuotationFreightModeOption } from "types/Common";
import { getDimensionalWeight, getPackingListCalculations } from "helpers/quotationFormHelper";
import Button from "components/atoms/Button/Button";
import CommoditiesDialog from "./commodity/CommoditiesDialog";

interface ServiceFormSidebarProps {
  selectedFreightModeObject?: QuotationFreightModeOption;
  quoteRequestDetails: any;
}
export default function ServiceFormSidebar({ selectedFreightModeObject, quoteRequestDetails }: ServiceFormSidebarProps) {
  const [showCommoditiesDialog, setShowCommoditiesDialog] = useState(false);

  const { totalWeight, weightUnit, totalCBM, listItems } = getPackingListCalculations(quoteRequestDetails) ?? {};

  const showDimensionalWeight =
    ["regular_air", "nfo", "air_charter"].includes(selectedFreightModeObject?.value ?? "") ||
    (selectedFreightModeObject?.is_custom_freight && selectedFreightModeObject.type === "air");

  return (
    <>
      <h6>
        <FormattedMessage id="general.freightMode" defaultMessage="Freight mode" />
      </h6>
      <div className="font-b3 text-secondary mt-1">
        <p className="mb-1 text-lowercase">
          {totalWeight} {weightUnit} <FormattedMessage id="general.grossWeight" defaultMessage="Gross weight" />
        </p>
        {showDimensionalWeight && (
          <p className="mb-1">
            {getDimensionalWeight(quoteRequestDetails?.organization?.good_items, weightUnit)} {weightUnit} Dimensional
            (MSF 6000)
          </p>
        )}
        <p className="mb-1">
          {totalCBM} <FormattedMessage id="general.totalCBM" defaultMessage="Total CBM" />
        </p>
        <p className="mb-1">{listItems?.join(", ")}</p>

        <Button variant="link" className="p-0 mt-4 mb-4" onClick={() => setShowCommoditiesDialog(true)}>
          <FormattedMessage id="quotation-form.viewCommodities" defaultMessage="View Commodities" />
        </Button>
      </div>
      <CommoditiesDialog isOpen={showCommoditiesDialog} close={() => setShowCommoditiesDialog(false)} />
    </>
  );
}

ServiceFormSidebar.defaultProps = {
  selectedFreightModeObject: undefined,
};
